const captchaKey = window.location.hostname.split('.').slice(-2).join('.');
const __RECAPTCHA_SITE_KEY = '6Lf-PBciAAAAAPt8JcrDsUuM4ocIID0CyPTq6QXq';

export const RECAPTCHA_SITE_KEY = __RECAPTCHA_SITE_KEY;
export const QQ_SITE_KEY = '189926997';
export enum CaptchaType {
  'geecaptcha' = 'geecaptcha',
  'recaptcha' = 'recaptcha',
  'qqcaptcha' = 'qqcaptcha',
}
